import {IImage, IButton} from './common.types';
import {ITile} from './tile.types';

export enum RailType {
    STANDARD = 'Standard',
    SPOTLIGHT = 'Spotlight',
    COMING_UP = 'ComingUp',
    SUBSCRIPTIONS = 'Subscriptions'
}

export interface IRailSliderConfig {
    slidesPerView: number;
    slidesPerGroup: number;
}

// Subscriptions Rail
export interface ISubscriptionTile {
    description: string;
    button: IButton;
    logo: IImage;
    image: IImage;
    badgeText: string;
    title?: string;
    competitionId?: string;
    competitionName?: string;
    assetId?: string;
    entitlementIds?: any;
    EntitlementIds?: any;
}

export interface ISubscriptionsRail {
    componentType: string;
    button?: IButton;
    title: string;
    description: string;
    tiles: ISubscriptionTile[];
    theme?: string;
    tileBackgroundColor?: string;
    showGradient?: boolean;
}

// Articles Rail
export interface IArticleTile {
    description: string;
    button: IButton;
    logo: IImage;
    image: IImage;
    badgeText: string;
    title?: string;
    competitionId?: string;
    competitionName?: string;
    assetId?: string;
    entitlementIds?: any;
    EntitlementIds?: any;
}

export interface IArticlesRail {
    componentType: string;
    button?: IButton;
    title: string;
    description: string;
    tiles: IArticleTile[];
    theme?: string;
    tileBackgroundColor?: string;
    showGradient?: boolean;
}

// Standarad Rail
export interface IStandardRail {
    componentType: string;
    title: string;
    description: string;
    tiles: ITile[];
    button?: IButton;
    railType: string;
    railId: string;
    railParams: any;
    theme?: string;
    tileBackgroundColor?: string;
    showGradient?: boolean;
}

// Coming Up Rail
export interface IComingUpTile {
    title: string;
    description: string;
    button: IButton;
    image: IImage;
    badgeText: string;
    showBadge: boolean;
    competitionId?: string;
    competitionName?: string;
    assetId?: string;
    entitlementIds?: any;
    EntitlementIds?: any;
}

export interface IComingUpRail {
    componentType: string;
    title: string;
    description?: string;
    tiles: IComingUpTile[];
    button?: IButton;
    railType: string;
    railId?: string;
    theme?: string;
    tileBackgroundColor?: string;
    showGradient?: boolean;
}

// Spotlight Rail

export interface ISpotlightRail {
    componentType: string;
    title: string;
    description: string;
    tiles: ITile[];
    button?: IButton;
    railType: string;
    railId: string;
    image: IImage;
    railParams: any;
}

// ShowsRail
export interface IShowsRail {
    componentType: string;
    title: string;
    description: string;
    tiles: ITile[];
    button?: IButton;
    railType: string;
    railId: string;
    railParams: any;
}

export type ILPTile = ITile | IComingUpTile | ISubscriptionTile | IArticleTile;

export type ILPRail =
    | IStandardRail
    | IComingUpRail
    | ISubscriptionsRail
    | IArticlesRail;
